import React from 'react'
import moment from 'moment'
import { Box, Image, Flex, Text, Link } from 'theme-ui'
import EventDate from './EventDate'
import EventDays from './EventDays'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlassCheers, faClock, faClipboard } from '@fortawesome/free-solid-svg-icons'

export default function EventsModal({ event, modalShowing, closeModal, variantName }) {
  const { name, starts, ends, description, imageurl, ctas } = event

  return modalShowing ? (
    <Box variant={`${variantName}.modalContainer`} className="modalContainer">
      <Box variant={`${variantName}.modalBackground`} className="modalBackground" onClick={() => closeModal()} />
      <Box variant={`${variantName}.modal`} className="modal">
        <Image variant={`${variantName}.modalImage`} src={imageurl} className="modalImage" alt="Modal_Event_Image" />

        <Box variant={`${variantName}.modalContentContainer`} className="modalContentContainer">
          <Text variant={`${variantName}.modalEventName`} className="modalEventName">
            {name}
          </Text>

          <Flex variant={`${variantName}.modalEventDate`} className="modalEventDate">
            {!event.eventDays && <EventDate date={starts} variantName={variantName} />}
            {/* <Heading variant={`${variantName}.datesSeperator`}>-</Heading>
            <EventDate date={ends} variantName={variantName} /> */}

            {event.eventDays && <EventDays eventDays={event.eventDays} variantName={variantName} />}
          </Flex>

          <Text variant={`${variantName}.modalEventTime`} className="modalEventTime">
            <FontAwesomeIcon style={{ marginRight: '10px', fontSize: '22px' }} icon={faClock} />
            {`${moment(starts).format('h:mm A')}`} - {`${moment(ends).format('h:mm A')}`}
          </Text>

          <Flex sx={{ marginBottom: 2 }} className="modalEventDescriptionContainer">
            <FontAwesomeIcon
              style={{
                marginRight: '14px',
                fontSize: '22px',
                marginLeft: '2px'
              }}
              icon={faClipboard}
            />
            <Text as="p" variant={`${variantName}.modalEventDescription`} className="modalEventDescription">
              {description}
            </Text>
          </Flex>

          {ctas ? (
            <Flex variant={`${variantName}.eventCTAS`} className="eventCTABtns">
              {Object.keys(ctas).map(ctaName => {
                if (ctas[ctaName]) {
                  return (
                    <Link variant={`${variantName}.eventCTA`} href={ctas[ctaName]} target="_blank" rel="noreferrer">
                      {ctaName}
                    </Link>
                  )
                }
              })}
            </Flex>
          ) : (
            ''
          )}
        </Box>
      </Box>
    </Box>
  ) : (
    ''
  )
}
